/* eslint-disable no-nested-ternary */
/* global G */
import { useContext, useMemo } from 'react'
import { Grid } from '@mui/material'
import ApplicationContext from 'platform/react/context/application'
import CellHOC from 'platform/react/hoc/list/cell'
import Text from 'ui/Element/Text'
import { getFirstItem } from 'lib/util'
import { isOlderThanOneDay } from 'lib/util/date'
import Chip from 'ui/Element/Text/Chip'

/**
 * Custom styles for the component.
 *
 * @param {Object} theme
 * @returns {Object}
 */
export const styles = theme => ({})

/**
 * Displays information about an OptionManagement scan.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
export const ListItemCellOptionManagementInfo = (classes, props) => {
  const { intl, session } = useContext(ApplicationContext)
  const currentLanguage = useMemo(() => session[G.LANGUAGE], [session])

  const {
    type = 'option',
    password,
    deviceInformation,
    serialNumber,
    equipment,
    location,
    submitDate,
    response,
  } = props

  const { refs: { product = [] } = {} } = equipment || {}
  const { value = {} } = getFirstItem(product) || {}
  const localizedNames = value?.['i18n:name']
  const localizedName = localizedNames?.[currentLanguage]

  const pinIsOutdated = type === 'pin'
    ? isOlderThanOneDay(submitDate)
    : false

  const {
    passwordGeneratedLabel,
    passwordNotGeneratedLabel,
    pinGeneratedLabel,
    pinNotGeneratedLabel,
    pinOutdatedLabel,
  } = props

  const submitDateLabel = intl.getLocaleDate(submitDate, { dateStyle: 'short', timeStyle: 'short' })
  const generatedLabel = type === 'option' ? passwordGeneratedLabel : pinGeneratedLabel
  const notGeneratedLabel = type === 'option' ? passwordNotGeneratedLabel : pinNotGeneratedLabel

  return (
    <Grid
      container
      direction={'column'}
      flexWrap={'nowrap'}
      alignItems={'flex-start'}
    >
      <Grid
        item
        container
        alignItems={'center'}
        flexWrap={'nowrap'}
        xs={12}
      >
        {deviceInformation && (
          <Grid
            item
            xs={12}
            component={Text}

            flexShrink={1}
            color={'black.main'}
            variant={'16/semiBold'}
          >
            {type === 'pin' ? localizedName || deviceInformation : deviceInformation}
          </Grid>
        )}
      </Grid>
      {location && (
        <Grid
          item
          xs={'auto'}
          component={Text}
          variant={'14/medium'}
        >
          {location}
        </Grid>
      )}
      {serialNumber && (
        <Grid
          item
          xs={'auto'}
          component={Text}
          color={'gray.400'}
          variant={'14/medium'}
        >
          {serialNumber}
        </Grid>
      )}
      <Grid
        item
        component={Text}
        variant={'14/medium'}
        xs={'auto'}
      >
        {submitDateLabel}
      </Grid>
      <Grid
        item
        container
        marginTop={0.5}
        justifyContent={'space-between'}
        alignItems={'center'}
        flexWrap={'nowrap'}
        xs={12}
      >
        <Grid
          item
          xs={'auto'}
        >
          <Chip
            size={'small'}
            textVariant={'12/medium'}
            value={pinIsOutdated
              ? pinOutdatedLabel
              : password
                ? generatedLabel
                : notGeneratedLabel}
            {...pinIsOutdated
              ? { color: 'error.700', backgroundColor: 'error.50' }
              : !response?.messageKey
                ? { color: 'success.700', backgroundColor: 'success.50' }
                : { color: 'warning.700', backgroundColor: 'warning.50' }
            }
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CellHOC(ListItemCellOptionManagementInfo, styles)
